import { render, staticRenderFns } from "./LiffPageConfigTreeEditor.vue?vue&type=template&id=65943cef&scoped=true&"
import script from "./LiffPageConfigTreeEditor.vue?vue&type=script&lang=js&"
export * from "./LiffPageConfigTreeEditor.vue?vue&type=script&lang=js&"
import style0 from "./LiffPageConfigTreeEditor.vue?vue&type=style&index=0&id=65943cef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65943cef",
  null
  
)

export default component.exports